"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineMaster2V2 = exports.BoxMaster2V2 = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var lodash_1 = require("lodash");
var react_infinite_scroller_1 = __importDefault(require("react-infinite-scroller"));
var input_1 = require("remota-client/hook/input");
var input_2 = require("./input");
var translate_1 = require("remota-common/util/translate");
var fat_1 = require("remota-common/util/fat");
var BoxMaster2V2 = function (props) {
    return react_1.default.createElement(Master2Inner, __assign({ inputType: "box" }, props));
};
exports.BoxMaster2V2 = BoxMaster2V2;
var LineMaster2V2 = function (props) {
    return react_1.default.createElement(Master2Inner, __assign({ inputType: "line" }, props));
};
exports.LineMaster2V2 = LineMaster2V2;
var MasterBoxInput = (0, styled_components_1.default)(input_2.BoxInput)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 28px;\n  border-radius: ", ";\n"], ["\n  height: 28px;\n  border-radius: ", ";\n"])), function (props) { return (props.isOpen ? props.theme.borderRadius.above : undefined); });
var MasterLineInput = (0, styled_components_1.default)(input_2.LineInput)(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
var MasterInputs = {
    box: MasterBoxInput,
    line: MasterLineInput,
};
var Master2Inner = function (props) {
    var _a;
    var value = props.value, onSearch = props.onSearch, onKeyDown = props.onKeyDown, onChange = props.onChange, onBlur = props.onBlur, onChangeAndExec = props.onChangeAndExec, _b = props.masters, masters = _b === void 0 ? [] : _b, searchStatus = props.searchStatus, searchNext = props.searchNext, inputRef = props.inputRef, inputType = props.inputType, startClosed = props.startClosed, rest = __rest(props, ["value", "onSearch", "onKeyDown", "onChange", "onBlur", "onChangeAndExec", "masters", "searchStatus", "searchNext", "inputRef", "inputType", "startClosed"]);
    var _c = __read(react_1.default.useState({
        query: (_a = value === null || value === void 0 ? void 0 : value.displayValue) !== null && _a !== void 0 ? _a : "",
        isOpen: startClosed ? false : true,
        focusingIndex: -1,
    }), 2), state = _c[0], setState = _c[1];
    var search = react_1.default.useMemo(function () { return (onSearch ? (0, lodash_1.debounce)(function (query) { return onSearch(query); }, 300) : lodash_1.noop); }, [onSearch]);
    var areaRef = react_1.default.useRef(null);
    var _d = __read((0, input_1.useIMEControl)(), 2), isComposing = _d[0], imeProps = _d[1];
    (0, input_1.useOutsideClick)(areaRef, function () { return onBlur && onBlur(); });
    var handleChange = function (e) {
        var query = e.target.value;
        setState(function (state) { return (__assign(__assign({}, state), { query: query, isOpen: true })); });
        search(query);
        if (query === "") {
            onChange && onChange(undefined);
        }
    };
    var setFocus = function (focusingIndex) {
        setState(__assign(__assign({}, state), { focusingIndex: focusingIndex }));
        onChange && onChange(masters[focusingIndex]);
    };
    var setValue = function (value) {
        setState(__assign(__assign({}, state), { query: value.displayValue, isOpen: false }));
        onChange && onChange(value);
    };
    var handleKeyDown = function (e) {
        if (!isComposing) {
            if (e.key === "ArrowUp" && state.focusingIndex > 0) {
                e.preventDefault();
                setFocus(state.focusingIndex - 1);
            }
            else if (e.key === "ArrowDown") {
                if (!state.isOpen) {
                    e.preventDefault();
                    setState(__assign(__assign({}, state), { isOpen: true, focusingIndex: 0 }));
                }
                else if (state.focusingIndex < masters.length - 1) {
                    e.preventDefault();
                    setFocus(state.focusingIndex + 1);
                }
            }
            else if (e.key === "Enter" && state.focusingIndex !== -1) {
                e.preventDefault();
                setValue(masters[state.focusingIndex]);
            }
            onKeyDown && onKeyDown(e);
        }
    };
    var handleSelect = function (value) {
        onChangeAndExec && onChangeAndExec(value);
        setState(__assign(__assign({}, state), { query: value.displayValue, isOpen: false }));
    };
    var MasterInput = MasterInputs[inputType];
    return (react_1.default.createElement(RootArea, { ref: areaRef },
        react_1.default.createElement(MasterInput, __assign({ isOpen: state.isOpen, value: state.query, onKeyDown: handleKeyDown, onChange: handleChange, onClick: function () { return setState(__assign(__assign({}, state), { isOpen: true })); } }, rest, imeProps, { ref: inputRef })),
        react_1.default.createElement(ResultArea, { isOpen: state.isOpen, inputType: inputType, maxCount: 9.5 },
            react_1.default.createElement(Results, { onSelect: handleSelect, focusingIndex: state.focusingIndex, masters: masters, searchStatus: searchStatus, searchNext: searchNext }))));
};
var Results = react_1.default.memo(function (props) {
    var _a;
    var onSelect = props.onSelect, focusingIndex = props.focusingIndex, masters = props.masters, searchStatus = props.searchStatus, searchNext = props.searchNext;
    var handleClick = react_1.default.useCallback(function (e) {
        var index = e.currentTarget.dataset.index;
        if (index && masters[Number(index)]) {
            onSelect(masters[Number(index)]);
        }
    }, [masters, onSelect]);
    var isLoading = (_a = searchStatus === null || searchStatus === void 0 ? void 0 : searchStatus.isLoading) !== null && _a !== void 0 ? _a : false;
    if (masters.length === 0 && !(searchStatus === null || searchStatus === void 0 ? void 0 : searchStatus.canSearchMore)) {
        return (react_1.default.createElement(ResultItem, { notSelectable: true }, isLoading ? (0, fat_1.deFat)((0, translate_1.fat)("Loading")) : (0, fat_1.deFat)((0, translate_1.fat)("結果が見つかりませんでした"))));
    }
    return (react_1.default.createElement(react_infinite_scroller_1.default, { loadMore: searchNext || lodash_1.noop, hasMore: searchStatus === null || searchStatus === void 0 ? void 0 : searchStatus.canSearchMore, useWindow: false }, masters.map(function (master, i) { return (react_1.default.createElement(ResultItem, { key: master.id, focusing: focusingIndex === i, "data-index": i, onClick: handleClick }, master.displayValue)); })));
});
var RootArea = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: relative;\n  z-index: 1;\n"], ["\n  position: relative;\n  z-index: 1;\n"])));
var ResultArea = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: absolute;\n\n  display: ", ";\n  flex-direction: column;\n  width: calc(100% - 2px);\n  max-height: ", "px;\n  overflow: scroll;\n\n  box-sizing: content-box;\n  top: ", ";\n  left: 0px;\n\n  background: ", ";\n  border-radius: ", ";\n  border: 1px ", " solid;\n  border-top: none;\n"], ["\n  position: absolute;\n\n  display: ", ";\n  flex-direction: column;\n  width: calc(100% - 2px);\n  max-height: ", "px;\n  overflow: scroll;\n\n  box-sizing: content-box;\n  top: ", ";\n  left: 0px;\n\n  background: ", ";\n  border-radius: ", ";\n  border: 1px ", " solid;\n  border-top: none;\n"])), function (props) { return (props.isOpen ? "flex" : "none"); }, function (props) { return props.maxCount * 24; }, function (props) {
    switch (props.inputType) {
        case "box":
            return "32px";
        case "line":
            return "24px";
    }
}, function (props) { return props.theme.colors.white; }, function (props) { return props.theme.borderRadius.beneath; }, function (props) { return props.theme.colors.tableGray1; });
var ResultItem = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  flex: 0 0 24px;\n  font-size: 12px;\n  line-height: 12px;\n  padding: 6px 12px;\n  box-sizing: border-box;\n\n  &:hover {\n    cursor: ", ";\n    background: ", ";\n  }\n\n  ", ";\n"], ["\n  flex: 0 0 24px;\n  font-size: 12px;\n  line-height: 12px;\n  padding: 6px 12px;\n  box-sizing: border-box;\n\n  &:hover {\n    cursor: ", ";\n    background: ", ";\n  }\n\n  ", ";\n"])), function (props) { return (props.notSelectable ? undefined : "pointer"); }, function (props) { return (props.notSelectable ? undefined : props.theme.colors.gray2Transparent); }, function (props) { return (props.focusing ? { background: props.theme.colors.gray2Transparent } : {}); });
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
